import classNames from 'classnames';

import { Tooltip } from '@material-ui/core';

import { ExchangeSwitchIcon } from 'components/Icons';

import css from './appNav.module.sass';

export default function ExchangeSwitchButton() {
  const handleClickButton = () => {
    window.location.replace(process.env.REACT_APP_MARKETPLACE_FRONT_URL || '');
  };

  return (
    <Tooltip title="Switch to Exchange" placement="bottom">
      <div className={classNames(css.exchangeViewSwitchButton, 'bg-appGrey150')} onClick={handleClickButton}>
        <ExchangeSwitchIcon className="text-appDark60" />
      </div>
    </Tooltip>
  );
}
